var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-row__wrapper" }, [
    _c(
      "div",
      {
        class: ["table-row", { clickable: _vm.clickableRows }],
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.clickHandler($event)
          }
        }
      },
      _vm._l(_vm.configuredData.rowData, function(cell, index) {
        return _c("Cell", {
          key: index,
          style: _vm.hasChildren ? "width: 100%;" : cell.columnWidth,
          attrs: {
            "delete-column": cell.type === "delete",
            "cell-data": cell,
            "show-expand-icon": _vm.hasChildren,
            expanded: _vm.expanded
          },
          on: {
            "toggle-expanded": _vm.toggleExpand,
            delete: _vm.deleteHandler,
            "btn-click": function($event) {
              return _vm.btnClickHandler(cell)
            }
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    _vm.expanded
      ? _c(
          "div",
          { staticClass: "table-row__children" },
          _vm._l(_vm.configuredData.children, function(child, index) {
            return _c("Row", {
              key: index,
              attrs: {
                config: _vm.config,
                "row-data": child,
                "clickable-rows": _vm.clickableRows
              },
              on: {
                "parent-click": function(val) {
                  return _vm.$emit("parent-click", val)
                },
                "row-click": function(val) {
                  return _vm.$emit("row-click", val)
                }
              }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }